export function CopyrightOverlay() {
  return (
    <div className="fixed bottom-2 right-2 z-50 pointer-events-none select-none">
      <span className="text-xs text-muted-foreground/50 font-light">
        Gently © 2025 support@gently-ai.com
      </span>
    </div>
  );
}
